<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mt-2 >
	    <v-btn :to="`/events/${this.$route.params.event_id}`">Event Home</v-btn>
      </v-flex>

      <v-flex mb-4 xs12 v-for="team in event_teams" :key="team.id">
          <h1>Team #{{team.id}} {{team.name}}</h1>
          <EventMyRoom v-for="room_allocation in team.room_allocations" :room_allocation="room_allocation" :key="room_allocation.id"/>

          <TeamTickets :team="team" />


          <hr/>
          <h2>Team Manager Change</h2>
          <v-btn class="vbtn2line" color='error' :to="`/events/${event.id}/my_team/${team.id}/swap_manager`">Pick Among Team Members<br/>팀 멤버에게 대표자 권한 넘기기</v-btn>
          <v-btn class="vbtn2line" color='error' :to="`/events/${event.id}/my_team/${team.id}/invite_manager`">Give Ticket/Rights to New Person<br/>새로운 멤버에게 대표자 권한과 티켓 동시 양도하기</v-btn>
      </v-flex >


    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import EventMyRoom from './EventMyRoom';
import TeamTickets from './TeamTickets';

export default {
  components: {EventMyRoom, TeamTickets},
  data: () => ({
    ready: false,
    room1_code: '',
    room2_code: '',
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (value.length >= 2 && value.length < 32) || 'At least 2 characters',
    },
    finished: false,
  }),
  beforeMount: async function() {
    this.$store.dispatch('loadEvents');
    this.$store.dispatch('loadAttendees');
    this.$store.dispatch('loadEventTeams', {
      event_id: this.$route.params.event_id,
    });
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees', 'event_teams']),
    event() {
      return (this.$data.event = this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      }));
    },
  },
  watch: {},
  methods: {},
};
</script>

<style>
.event_profile_code {
  font-size: 3em;
  border: 1px solid black;
}

.vbtn2line {
  height: 3em;
}
</style>
